import { Block, parseBlock, serializeBlock } from './Block';
import { sanitizeBlockHtml } from '../helpers/htmlSanitizer';

export interface Wod {
  id: number;
  boxId: number;
  title: string;
  date: Date;
  warm_up: string;
  competitor: number;
  strengthIntensity: number | null;
  strengthTime: number | null;
  resistanceIntensity: number | null;
  resistanceTime: number | null;
  flexibilityIntensity: number | null;
  flexibilityTime: number | null;
  wodRoot?: number;
  bodyBuilding: number;
  weightLifting: number;
  pushSent: number;
  blocks: Block[];
  is_deleted: number; // cuando es 1 indica que se elimino y no deve mostrarse en la lista
  type_id: number;
}

export const parseWod = (json: any): Wod => {
  const parsedBlocks = Array.isArray(json.blocks)
    ? json.blocks.map((b: any) => parseBlock(b)).filter((blk: Block) => blk.is_deleted !== 1)
    : [];

  // 🔍 DEBUG: Log de bloques parseados
  if (parsedBlocks.length !== (Array.isArray(json.blocks) ? json.blocks.length : 0)) {
    console.log('[parseWod DEBUG] Bloques filtrados por is_deleted:', {
      wodId: json.id,
      wodTitle: json.title,
      bloquesOriginales: Array.isArray(json.blocks) ? json.blocks.length : 0,
      bloquesParseados: parsedBlocks.length,
      bloquesEliminados: (Array.isArray(json.blocks) ? json.blocks.length : 0) - parsedBlocks.length,
      bloquesEliminadosDetalle: Array.isArray(json.blocks)
        ? json.blocks
            .filter((b: any) => b.is_deleted === 1)
            .map((b: any) => ({ id: b.id, title: b.title, is_deleted: b.is_deleted }))
        : [],
    });
  }

  return {
    id: json.id,
    boxId: json.box_id,
    title: json.title,
    date: new Date(json.date),
    // Sanitizar HTML del campo warm_up para eliminar tags peligrosos (h1, h2, div, span, etc.)
    // Esto previene que HTML de editores ricos rompa el layout
    warm_up: sanitizeBlockHtml(json.warm_up ?? ''),
    competitor: json.competitor ?? 0,
    strengthIntensity: json.strength_intensity ?? null,
    strengthTime: json.strength_time ?? null,
    resistanceIntensity: json.resistance_intensity ?? null,
    resistanceTime: json.resistance_time ?? null,
    flexibilityIntensity: json.flexibility_intensity ?? null,
    flexibilityTime: json.flexibility_time ?? null,
    wodRoot: json.wod_root,
    bodyBuilding: json.body_building ?? 0,
    weightLifting: json.weight_lifting ?? 0,
    pushSent: json.push_sent ?? 0,
    blocks: parsedBlocks,
    is_deleted: json.is_deleted ?? 0,
    type_id: json.type_id ?? 0,
  };
};

export const serializeWod = (wod: Wod): any => ({
  id: wod.id,
  box_id: wod.boxId,
  title: wod.title,
  date: wod.date.toISOString().split('T')[0],
  warm_up: wod.warm_up,
  competitor: wod.competitor,
  strength_intensity: wod.strengthIntensity,
  strength_time: wod.strengthTime,
  resistance_intensity: wod.resistanceIntensity,
  resistance_time: wod.resistanceTime,
  flexibility_intensity: wod.flexibilityIntensity,
  flexibility_time: wod.flexibilityTime,
  wod_root: wod.wodRoot,
  body_building: wod.bodyBuilding,
  weight_lifting: wod.weightLifting,
  push_sent: wod.pushSent,
  blocks: wod.blocks.map((b) => serializeBlock(b)),
  is_deleted: wod.is_deleted,
  type_id: wod.type_id,
});
